export const LANGUAGES = {
  MENUBAR: {
    '홈': { en: 'Home', jp: 'ホーム', ko: '홈', ch: '首页', ru: 'Главная' },
    '블로그': { en: 'Blogs', jp: 'ブログ', ko: '블로그', ch: '博客', ru: 'Блоги' },
    '질문': { en: 'Q&A', jp: 'よくある質問', ko: 'QnA', ch: '问答', ru: 'Вопросы и ответы' },
    '캘린더': { en: 'Calendar', jp: 'カレンダー', ko: '캘린더', ch: '日历', ru: 'Календарь' },
  },
  MAIN_PAGE: {
    TITLE: {
      '한번 하면 돌이킬 수 없는 성형': { 
        en: 'Plastic surgery is irreversible', 
        jp: '一度行うと元に戻せない美容整形', 
        ko: '한번 하면 돌이킬 수 없는 성형', 
        ch: '整形手术一旦完成便无法逆转', 
        ru: 'Пластическая хирургия необратима' 
      },
      '당신은 얼마나 준비 됬나요': { 
        en: 'How prepared are you?', 
        jp: 'あなたはどれだけ準備ができていますか？', 
        ko: '당신은 얼마나 준비 됬나요?', 
        ch: '您准备好了吗？', 
        ru: 'Насколько вы готовы?' 
      },
      '수술후 관리를 더 체계적으로 해보세요': {
        en: 'Manage your post-surgery care more systematically',
        jp: '手術後のケアをより体系的に行いましょう',
        ko: '수술후 관리를 더 체계적으로 해보세요',
        ch: '让您的术后护理更加系统化',
        ru: 'Организуйте послеоперационный уход более систематически'
      },
      '캘린더로 손쉽게 관리하세요': {
        en: 'Easily manage with a calendar',
        jp: 'カレンダーで簡単に管理',
        ko: '캘린더로 손쉽게 관리하세요',
        ch: '使用日历轻松管理',
        ru: 'Легко управляйте с помощью календаря'
      },
      '에서 당신의 성형 여정을 완벽하게 준비하세요': { 
        en: 'Prepare perfectly for your plastic surgery journey at', 
        jp: 'であなたの美容整形の旅を完璧に準備してください', 
        ko: '에서 당신의 성형 여정을 완벽하게 준비하세요', 
        ch: '在我们这里为您的整形之旅做好完美准备', 
        ru: 'Подготовьтесь к путешествию в пластическую хирургию в' 
      }
    },
    CALENDAR_TITLE: {
      '성형 수술 회복 캘린더': { 
        en: 'Plastic Surgery Recovery Calendar',
        jp: '美容整形手術の回復カレンダー',
        ko: '성형 수술 회복 캘린더',
        ch: '整形手术康复日历',
        ru: 'Календарь восстановления после пластической хирургии'
      },
      '수술 전후 맞춤형 관리 일정을 확인하세요': {
        en: 'Check your personalized care schedule before and after surgery',
        jp: '手術前後のパーソナライズされたケアスケジュールを確認してください',
        ko: '수술 전후 맞춤형 관리 일정을 확인하세요',
        ch: '查看手术前后的个性化护理计划',
        ru: 'Проверьте ваш индивидуальный график ухода до и после операции'
      }
    },
    BLOGS_TITLE: {
      '최신 성형 블로그': {
        en: 'Latest Plastic Surgery Blogs',
        jp: '最新の美容整形ブログ',
        ko: '최신 성형 블로그',
        ch: '最新整形博客',
        ru: 'Последние блоги о пластической хирургии'
      },
      '유용한 성형 정보와 의료 소식을 확인하세요': {
        en: 'Check useful plastic surgery information and medical blogs',
        jp: '役立つ美容整形情報と医療ブログをご確認ください',
        ko: '유용한 성형 정보와 의료 블로그를 확인하세요',
        ch: '浏览有用的整形信息和医疗博客',
        ru: 'Ознакомьтесь с полезной информацией о пластической хирургии и медицинскими блогами'
      },
      '모든 블로그 보기': {
        en: 'View All Blogs',
        jp: 'すべてのブログを見る',
        ko: '모든 블로그 보기',
        ch: '查看所有博客',
        ru: 'Просмотреть все блоги'
      }
    },
    BUTTON: {
      '나만의 회복 캘린더 만들기': {
        en: 'Create My Recovery Calendar',
        jp: '自分の回復カレンダーを作成',
        ko: '나만의 회복 캘린더 만들기',
        ch: '创建我的恢复日历',
        ru: 'Создать мой календарь восстановления'
      }
    },
    INTEREST: {
      '배우고 싶은 분야를 선택 해주세요': {
        ko: '배우고 싶은 분야를 선택 해주세요',
        en: 'Please select a field you would like to learn about',
        jp: '学びたい分野を選択してください',
        ru: 'Пожалуйста, выберите область, о которой вы хотели бы узнать',
        zh: '请选择您想学习的领域'
      },
      '코': {
        ko: '코',
        en: 'Nose',
        jp: '鼻',
        ru: 'Нос',
        zh: '鼻子'
      },
      '눈': {
        ko: '눈',
        en: 'Eyes',
        jp: '目',
        ru: 'Глаза',
        zh: '眼睛'
      },
      '마취': {
        ko: '마취',
        en: 'Anesthesia',
        jp: '麻酔',
        ru: 'Анестезия',
        zh: '麻醉'
      },
      '수술 준비': {
        ko: '수술 준비',
        en: 'Surgery Preparation',
        jp: '手術準備',
        ru: 'Подготовка к операции',
        zh: '手术准备'
      },
      '병원 선택법': {
        ko: '병원 선택법',
        en: 'How to Choose a Clinic',
        jp: '病院の選び方',
        ru: 'Как выбрать клинику',
        zh: '医院选择方法'
      },
      '기타': {
        ko: '기타',
        en: 'Others',
        jp: 'その他',
        ru: 'Прочее',
        zh: '其他'
      },
      '재수술': {
        ko: '재수술',
        en: 'Revision Surgery',
        jp: '再手術',
        ru: 'Повторная операция',
        zh: '修复手术'
      },
      '수술 후 케어법': {
        ko: '수술 후 케어법',
        en: 'Post-Surgery Care',
        jp: '手術後のケア方法',
        ru: 'Послеоперационный уход',
        zh: '术后护理方法'
      },
      '부작용': {
        ko: '부작용',
        en: 'Side Effects',
        jp: '副作用',
        ru: 'Побочные эффекты',
        zh: '副作用'
      },
      '상담준비': {
        ko: '상담준비',
        en: 'Consultation Prep',
        jp: 'カウンセリング準備',
        ru: 'Подготовка к консультации',
        ch: '咨询准备'
      },
    },
    INTEREST_NOSE: {
      '개방형': { en: 'Open Rhinoplasty', jp: 'オープン法', ko: '개방형', ch: '开放式鼻整形', ru: 'Открытая ринопластика' },
      '비개방형': { en: 'Closed Rhinoplasty', jp: 'クローズド法', ko: '비개방형', ch: '闭合式鼻整形', ru: 'Закрытая ринопластика' },
      '자가진피와 보형물 차이': { en: 'Difference Between Autologous Dermis and Implant', jp: '自家真皮とインプラントの違い', ko: '자가진피와 보형물 차이', ch: '自体真皮与假体的区别', ru: 'Разница между аутологичным дермисом и имплантатом' }
    },
    RECOVERY: {
      '코 성형': { en: 'Rhinoplasty', jp: '鼻整形', ko: '코 성형', ch: '鼻整形', ru: 'Ринопластика' },
      '회복 타임라인': { en: 'Recovery Timeline', jp: '回復タイムライン', ko: '회복 타임라인', ch: '恢复时间表', ru: 'График восстановления' },
      '수술 회복 일정표': { en: 'Surgery Recovery Calendar', jp: '手術回復スケジュール', ko: '수술 회복 일정표', ch: '手术恢复日程表', ru: 'Календарь восстановления после операции' },
      '오늘의 회복 관리 가이드': { en: 'Today\'s Recovery Guide', jp: '今日の回復ガイド', ko: '오늘의 회복 관리 가이드', ch: '今日的恢复指南', ru: 'Руководство по восстановлению на сегодня' },
      '일상 복귀 진행 상황': { en: 'Return to Daily Life Progress', jp: '日常生活への復帰状況', ko: '일상 복귀 진행 상황', ch: '恢复日常生活进度', ru: 'Прогресс возвращения к повседневной жизни' },
      '중요 안내사항': { en: 'Important Notice', jp: '重要なお知らせ', ko: '중요 안내사항', ch: '重要提示', ru: 'Важное уведомление' },
      '샤워 가능': { en: 'Shower Below Neck', jp: '首から下のシャワー可能', ko: '목 아래 샤워 가능', ch: '颈部以下可淋浴', ru: 'Душ ниже шеи' },
      '출근 가능': { en: 'Return to Work', jp: '出勤可能', ko: '실밥 제거 및 출근 가능', ch: '拆线及复工', ru: 'Снятие швов и возвращение на работу' },
      '비행 가능': { en: 'Flying Allowed', jp: '飛行可能', ko: '비행 가능', ch: '可以乘坐飞机', ru: 'Полеты разрешены' },
      '가벼운 운동': { en: 'Light Exercise', jp: '軽い運動', ko: '가벼운 운동 가능', ch: '可进行轻度运动', ru: 'Легкие упражнения разрешены' },
      '음주 가능': { en: 'Alcohol Allowed', jp: '飲酒可能', ko: '음주 가능', ch: '可以饮酒', ru: 'Алкоголь разрешен' },
      '얼굴 마사지': { en: 'Face Massage Allowed', jp: '顔のマッサージ可能', ko: '얼굴 마사지 가능', ch: '可以进行面部按摩', ru: 'Массаж лица разрешен' },
      '격렬한 운동': { en: 'Intense Exercise Allowed', jp: '激しい運動可能', ko: '격렬한 운동 가능', ch: '可进行剧烈运动', ru: 'Интенсивные упражнения разрешены' },
      '최종 모양 완성': { en: 'Final Shape Completed', jp: '最終形状の完成', ko: '최종 모양 완성', ch: '最终形状完成', ru: 'Окончательная форма завершена' },
      '오늘의 위로와 격려': { 
        en: 'Today\'s Encouragement', 
        jp: '今日の励まし', 
        ko: '오늘의 위로와 격려', 
        ch: '今日的鼓励', 
        ru: 'Сегодняшнее воодушевление' 
      },
      '성형 수술 회복 여정 메시지': { 
        en: 'On your plastic surgery recovery journey, you are getting better every day. Prepare for a better tomorrow with today\'s care.', 
        jp: '美容整形の回復の旅で、あなたは毎日良くなっています。今日のケアで明日のより良い状態に備えましょう。', 
        ko: '성형 수술 회복 여정을 시작하신 당신께, 매일 조금씩 나아지고 있어요. 오늘의 관리로 더 나은 내일을 준비하세요.', 
        ch: '在您的整形手术恢复旅程中，您每天都在好转。通过今天的护理为更美好的明天做准备。', 
        ru: 'В вашем пути восстановления после пластической хирургии вы становитесь лучше с каждым днем. Подготовьтесь к лучшему завтра с помощью сегодняшнего ухода.' 
      },
      '주요 회복 단계': { 
        en: 'Key Recovery Stages', 
        jp: '主な回復段階', 
        ko: '주요 회복 단계', 
        ch: '关键恢复阶段', 
        ru: 'Ключевые этапы восстановления' 
      },
      '주의사항': { 
        en: 'Precautions', 
        jp: '注意事項', 
        ko: '주의사항', 
        ch: '注意事项', 
        ru: 'Меры предосторожности' 
      },
      '냉찜질 안내': { 
        en: 'Cold compress: 5-7 times a day, 20 minutes each (wrap with towel, don\'t apply directly)', 
        jp: '冷湿布：1日5〜7回、各20分間（タオルで包み、直接当てないでください）', 
        ko: '냉찜질: 하루 5-7회, 20분씩 (얼굴에 직접 대지 말고 수건으로 감싸서)', 
        ch: '冷敷：每天5-7次，每次20分钟（用毛巾包裹，不要直接敷在脸上）', 
        ru: 'Холодный компресс: 5-7 раз в день, по 20 минут каждый (заверните в полотенце, не прикладывайте напрямую)' 
      },
      '처방약 안내': { 
        en: 'Take prescribed medication at exact times (30 min after meals, 3 times daily)', 
        jp: '処方薬を正確な時間に服用してください（食後30分、1日3回）', 
        ko: '처방약 정확한 시간에 복용 (식후 30분, 하루 3회)', 
        ch: '在准确的时间服用处方药（饭后30分钟，每天3次）', 
        ru: 'Принимайте прописанные лекарства в точное время (через 30 минут после еды, 3 раза в день)' 
      },
      '베개 높이기 안내': { 
        en: 'Keep head elevated with 2-3 pillows to reduce swelling', 
        jp: '2〜3個の枕で頭を高く保ち、腫れを軽減します', 
        ko: '베개 2-3개로 머리를 높게 유지하여 붓기 감소', 
        ch: '用2-3个枕头将头部垫高以减少肿胀', 
        ru: 'Держите голову приподнятой с помощью 2-3 подушек, чтобы уменьшить отечность' 
      }
    },
    CAUTION_MESSAGES: {
      '코 부위 충격 금지': {
        en: 'No strong impact to nose area',
        jp: '鼻の部分への強い衝撃禁止',
        ko: '코 부위 강한 충격 금지',
        ch: '禁止鼻部强烈冲击',
        ru: 'Запрет сильных ударов в область носа'
      },
      '무리한 운동 자제': {
        en: 'Avoid excessive exercise and high-intensity activities',
        jp: '無理な運動や高強度の活動を控える',
        ko: '무리한 운동 및 고강도 활동 자제',
        ch: '避免过度运动和高强度活动',
        ru: 'Избегайте чрезмерных физических нагрузок и высокоинтенсивной деятельности'
      },
      '과도한 알코올 금지': {
        en: 'Avoid excessive alcohol consumption and smoking',
        jp: '過度のアルコール摂取と喫煙を禁止',
        ko: '과도한 알코올 섭취와 흡연 금지',
        ch: '禁止过量饮酒和吸烟',
        ru: 'Запрет чрезмерного употребления алкоголя и курения'
      },
      '코 압력 행동 금지': {
        en: 'Avoid actions that put pressure on your nose (blowing nose, strong sneezing, wearing glasses)',
        jp: '鼻に圧力をかける行為を禁止（鼻をかむ、強いくしゃみ、メガネの着用）',
        ko: '코에 압력을 주는 행동 금지(코 풀기, 강한 재채기, 안경착용)',
        ch: '禁止对鼻子施加压力的行为（擤鼻子、用力打喷嚏、戴眼镜）',
        ru: 'Запрет действий, оказывающих давление на нос (сморкание, сильное чихание, ношение очков)'
      }
    },
    RECOVERY_MESSAGES: {
      '-7': {
        en: 'Stop alcohol and smoking completely, discontinue blood-thinning medications (like aspirin), prepare arnica ointment, ice packs, and heat packs, get prescription medications in advance',
        jp: 'アルコールとタバコを完全に中止し、血液凝固阻害薬（アスピリンなど）を中止し、アルニカ軟膏、氷のパック、温熱パックを準備し、処方薬を事前に準備してください',
        ko: '술과 담배 완전 중단, 혈액응고 방해 약물(아스피린 등) 중단, 아르니카 연고 준비, 얼음팩 및 온찜질 팩 준비, 처방약 미리 준비',
        ch: '完全停止饮酒和吸烟，停止使用干扰血液凝固的药物（如阿司匹林），准备好芦荟软膏、冰袋和热敷袋，提前准备好处方药',
        ru: 'Полностью прекратите употребление алкоголя и курение, прекратите прием препаратов, препятствующих свертыванию крови (например, аспирина), подготовьте мазь арники, пакеты со льдом и теплые компрессы, заранее подготовьте лекарства по рецепту'
      },
      '-1': {
        en: 'Prepare comfortable clothes for surgery day, prepare for fasting (strictly fast for 8 hours before surgery), get plenty of sleep in advance',
        jp: '手術当日に着る快適な服を準備し、絶食の準備をし（手術前の8時間は厳密に絶食）、事前に十分な睡眠をとってください',
        ko: '수술 당일 입을 편한 옷 준비, 금식 준비(수술 전 8시간 금식 철저히), 미리 충분한 수면',
        ch: '准备手术当天穿的舒适衣物，准备禁食（手术前8小时严格禁食），提前充分休息',
        ru: 'Подготовьте удобную одежду для дня операции, подготовьтесь к голоданию (строго голодайте за 8 часов до операции), заранее хорошо выспитесь'
      },
      '0': {
        en: 'Surgery day: No makeup after washing face, no contact lenses, strictly adhere to fasting (including water), bring prescription medications and ID, have a guardian accompany you, start ice compression after arriving home',
        jp: '手術当日：洗顔後のメイク禁止、コンタクトレンズ禁止、厳密に絶食を守り（水を含む）、処方薬と身分証明書を持参し、保護者同伴で、帰宅後に氷冷却を開始してください',
        ko: '수술 당일: 세안 후 화장 금지, 렌즈 착용 금지, 금식 철저히 준수(물 포함), 처방약 및 신분증 지참, 보호자 동행, 집 도착 후 얼음찜질 시작',
        ch: '手术当天：洗脸后禁止化妆，禁止佩戴隐形眼镜，严格遵守禁食（包括水），携带处方药和身份证明，监护人陪同，到家后立即开始冰敷',
        ru: 'День операции: запрет на макияж после умывания, запрет на контактные линзы, строгое соблюдение голодания (включая воду), возьмите с собой рецептурные лекарства и удостоверение личности, сопровождение опекуна, начните ледяной компресс после прибытия домой'
      },
      '3': {
        en: 'This is when swelling and bruising are at their worst. If you endure this period well, beautiful results will be waiting for you. Hang in there! Switch from cold to warm compresses, keep head elevated, showering below neck is possible',
        jp: 'これは腫れと内出血が最もひどい時期です。この時期をうまく乗り切れば、素晴らしい結果が待っています。もう少し頑張ってください！冷湿布から温湿布に切り替え、頭を高く保ち、首から下のシャワーが可能です',
        ko: '지금 붓기와 멍이 제일 심한 때입니다. 이 시기만 잘 견디시면 정말 아름다운 결과가 기다리고 있을 거예요. 조금만 더 힘내세요! 냉찜질에서 온찜질로 전환, 베개 높게 유지, 목 아래 부분 샤워 가능',
        ch: '这是肿胀和瘀伤最严重的时候。如果您能好好忍受这个时期，美丽的结果将等着您。再坚持一下！从冷敷转为热敷，保持头部抬高，可以淋浴颈部以下部位',
        ru: 'Это когда отек и синяки находятся в наихудшем состоянии. Если вы хорошо перенесете этот период, вас будут ждать прекрасные результаты. Держитесь! Переключитесь с холодных компрессов на теплые, держите голову приподнятой, возможен душ ниже шеи'
      },
      '7': {
        en: 'It\'s already time for stitch removal! After the initial difficulties, you\'re recovering quickly. You\'re doing really well. Stitch removal (hospital visit required), gentle cleansing possible, full return to daily life',
        jp: 'もう抜糸の日です！最初の困難を乗り越え、あなたは速く回復しています。本当によくやっています。抜糸（病院訪問が必要）、優しい洗顔開始可能、日常生活への本格的な復帰',
        ko: '벌써 실밥 제거 날이네요! 처음의 어려움이 지나고 빠르게 회복하고 있어요. 정말 잘하고 있습니다. 실밥 제거(병원 방문 필수), 부드러운 세안 시작 가능, 일상 복귀 본격화',
        ch: '已经是拆线的日子了！度过了最初的困难，您正在迅速恢复。您做得非常好。拆线（必须到医院），可以开始轻柔洗脸，全面恢复日常生活',
        ru: 'Уже пора снимать швы! После первоначальных трудностей вы быстро восстанавливаетесь. Вы действительно хорошо справляетесь. Снятие швов (требуется посещение больницы), возможно мягкое очищение, полное возвращение к повседневной жизни'
      },
      '14': {
        en: 'Recovery is visibly progressing! While you still need to be careful, you can go out and gradually return to your normal life. Light aerobic exercise possible, still avoid alcohol and smoking',
        jp: '回復の速度が目に見えてきましたね！まだ注意は必要ですが、短い外出をして、少しずつ日常を取り戻しましょう。軽い有酸素運動可能、アルコールと喫煙はまだ禁止',
        ko: '회복 속도가 눈에 띄네요! 아직 조심해야 하지만, 가벼운 외출도 하며 조금씩 일상을 찾으세요. 가벼운 유산소 운동 가능, 아직 음주·흡연 금지',
        ch: '恢复速度明显加快！虽然您仍需小心，但可以外出并逐渐恢复正常生活。可进行轻度有氧运动，仍禁止饮酒和吸烟',
        ru: 'Восстановление заметно прогрессирует! Хотя вам все еще нужно быть осторожным, вы можете выходить на улицу и постепенно возвращаться к нормальной жизни. Возможны легкие аэробные упражнения, по-прежнему избегайте алкоголя и курения'
      },
      '30': {
        en: 'It\'s been a month already! This is the time when you start seeing the truly beautiful results. It will soon settle into an even better appearance! Facial massage possible, most swelling reduced, be careful about applying pressure around the nose',
        jp: 'すでに1ヶ月が経ちました！これから本当に美しい結果が見られる時期です。まもなくさらに素晴らしい姿に落ち着くでしょう！顔のマッサージ可能、ほとんどの腫れが減少、鼻周りに圧力をかける行動に注意',
        ko: '어느덧 한 달이 되었네요! 지금부터가 진짜 아름다운 결과를 만나는 시기입니다. 곧 더 멋진 모습으로 자리 잡을 거예요! 얼굴 마사지 가능, 대부분의 붓기 감소, 코 주위 압력 가하는 행동 주의',
        ch: '已经一个月了！现在是开始看到真正美丽结果的时候。它很快会形成更美丽的外观！可以进行面部按摩，大部分肿胀已消退，注意避免在鼻子周围施加压力',
        ru: 'Прошел уже месяц! Это время, когда вы начинаете видеть действительно красивые результаты. Скоро они превратятся в еще лучший вид! Возможен массаж лица, большая часть отеков уменьшилась, будьте осторожны с давлением вокруг носа'
      },
      '180': {
        en: 'Nose shape is stabilized and settled in place, regular check-ups recommended (hospital visits every 3 months)',
        jp: '鼻の最終形状が安定し、定着しました。定期的な検診（3ヶ月ごとの病院訪問を推奨）',
        ko: '코 최종 모양 안정 및 자리 잡음, 정기적 검진(3개월 간격으로 병원 방문 권장)',
        ch: '鼻子最终形态稳定并固定，建议定期检查（建议每3个月到医院检查一次）',
        ru: 'Форма носа стабилизировалась и установилась на месте, рекомендуются регулярные осмотры (посещение больницы каждые 3 месяца)'
      }
    }
  },
  BLOG_PAGE: {
    '블로그 및 트렌드': { en: 'Blogs & Trends', jp: 'ブログ＆トレンド', ko: '블로그 및 트렌드', ch: '博客与趋势', ru: 'Блоги и тренды' },
    '준비 중입니다': { en: 'Coming Soon', jp: '準備中です', ko: '준비 중입니다', ch: '即将推出', ru: 'Скоро будет доступно' },
    '곧 멋진 블로그와 트렌드가 여러분을 찾아갑니다': { 
      en: 'Great blogs and trends will come to you soon', 
      jp: 'すぐに素晴らしいブログとトレンドをお届けします', 
      ko: '곧 멋진 블로그와 트렌드가 여러분을 찾아갑니다', 
      ch: '精彩博客和趋势即将呈现', 
      ru: 'Отличные блоги и тренды скоро будут доступны' 
    }
  },
  LANGUAGE_SELECTOR: {
    '언어 선택': { en: 'Language', jp: '言語', ko: '언어 선택', ch: '选择语言', ru: 'Язык' },
    '한국어': { en: 'Korean', jp: '韓国語', ko: '한국어', ch: '韩语', ru: 'Корейский' }, 
    '영어': { en: 'English', jp: '英語', ko: '영어', ch: '英语', ru: 'Английский' },
    '일본어': { en: 'Japanese', jp: '日本語', ko: '일본어', ch: '日语', ru: 'Японский' },
    '중국어': { en: 'Chinese', jp: '中国語', ko: '중국어', ch: '中文', ru: 'Китайский' },
    '러시아어': { en: 'Russian', jp: 'ロシア語', ko: '러시아어', ch: '俄语', ru: 'Русский' }
  },
  QNA_PAGE: {

  }
}